import { render } from "./DefaultHeader.vue?vue&type=template&id=8d6c5452&scoped=true"
import script from "./DefaultHeader.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&lang=js"

import "./DefaultHeader.vue?vue&type=style&index=0&id=8d6c5452&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6c5452"]])

export default __exports__